import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';
import { ScoreRecipientRegDto } from 'src/app/core/dtos/dto';
import { ProductTypeEnum } from 'src/app/core/dtos/enum';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { DateTimeHelper } from 'src/app/core/services/helpers/date-time.helper';
import { ProductService } from 'src/app/core/services/product.service';
import { RegistrationService } from 'src/app/core/services/registration.service';
import { ShippingPreference, ShippingPreferenceOption } from '../shipping-preference-option';

@Component({
  selector: 'app-order-hardcopy-score-service-cael',
  templateUrl: './order-hardcopy-score-service-cael.component.html',
  styleUrls: ['./order-hardcopy-score-service-cael.component.scss']
})
export class OrderHardcopyScoreServiceCaelComponent implements OnInit {

  @Output() priorityShippingSubmit = new EventEmitter<ShippingPreference>();
  @Input() institution: ScoreRecipientRegDto;
  @Input() regId: number;

  isBulkScore: boolean;
  selectedOption: ShippingPreferenceOption;
  noMailOption: ShippingPreferenceOption;
  regularMailOption: ShippingPreferenceOption;
  priorityShippingOption: ShippingPreferenceOption;
  isOldScoreReportOrder: boolean;

  constructor(
    private toastService: HotToastService,
    private registrationService: RegistrationService,
    private productService: ProductService
  ) { }

  ngOnInit(): void {
    //2022-07-19 is the release date for TEC-14035 22, 7, 20) one day before deployment
    this.isOldScoreReportOrder = (new Date(this.institution.dateCreatedUtc) < new Date(Date.UTC(2022, 7, 20))) ? true : false;
    this.checkIsInstitutionWithNoPhysicalScoreReport(this.institution.scoreRecipient.id);
  }

  checkIsInstitutionWithNoPhysicalScoreReport(institutionId: number) {
    this.registrationService.checkBulkDownloadFeatureForCurrentInstitution(institutionId).subscribe(
      result => {
        this.isBulkScore = result.content;
        if (result.content === false) {
          this.createShippingPreferenceOptions();
        }
      },
      (error: HttpErrorResponse) => {
        if (error.status === 400) {
          const errorMessage = error.error as HttpErrorResponseMessages;
          errorMessage.reasons.forEach(reasons => {
            this.toastService.warning(reasons.errorMessage);
          });
        }
      });
  }

  createShippingPreferenceOptions() {
    this.noMailOption = {
      productId: 0,
      shortDescription: "No, I do not require a hard copy Score Report to be sent to the institution.",
      price: 0,
    };
    this.selectedOption = this.noMailOption;
    this.regularMailOption = {
      productId: 1,
      description: "5-10 business days within Canada and to the United States from the time it is shipped from our office",
      price: 0,
      shortDescription: "Regular mail",
    };

    // there should be only one active product with productTypeId = ProductTypeEnum.ExpressScoreShippingService
    this.productService.getProductByTypeId(ProductTypeEnum.ExpressScoreShippingService)
      .subscribe(
        (result) => {
          this.priorityShippingOption = {
            productId: result.content[0].id,
            description: "2-4 business days from the time it is shipped from our office",
            price: result.content[0].listPrice,
            shortDescription: "Priority Shipping within Canada and the United States",
          };
        },
        (error: HttpErrorResponse) => {
          if (error.status === 400) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            errorMessage.reasons.forEach(reasons => {
              this.toastService.warning(reasons.errorMessage);
            });
          }
        });
  }

  shipmentPreferenceUpdated() {
    if (this.selectedOption.productId !== 0) {
      this.priorityShippingSubmit.emit({ productId: this.selectedOption.productId, price: this.selectedOption.price, institution: this.institution });
    }
  }

}
